import { Table } from "../../components/Table"
import { useAdminWebhooks } from "../../hooks/useApi"

export default function WebhooksPage() {
  const { data, isLoading, error } = useAdminWebhooks()
  const rows = data?.items ?? []

  if (isLoading) {
    return <p className="small">Loading webhook events…</p>
  }

  if (error) {
    return <p className="small">Unable to load webhook events.</p>
  }

  return (
    <Table
      data={rows}
      getRowId={(row) => String(row.id)}
      columns={[
        { key: "event_id", title: "Event" },
        { key: "type", title: "Type" },
        {
          key: "processed_at",
          title: "Processed",
          render: (row) => <span>{row.processed_at ? new Date(row.processed_at).toLocaleString() : "—"}</span>,
        },
        { key: "connected_account", title: "Account" },
      ]}
    />
  )
}
